import { render, staticRenderFns } from "./PlaneacionCorreo.vue?vue&type=template&id=425b1b36"
import script from "./PlaneacionCorreo.vue?vue&type=script&lang=js"
export * from "./PlaneacionCorreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports